import { Channel } from 'types'

import { aggregationDimensionOptionsMap } from '../../consts'
import { AggregationDimensionValue } from '../../TicketsVolumeDetails'

export const getBaseDimensionValue = (channel: Channel): AggregationDimensionValue => {
  const dimension = aggregationDimensionOptionsMap[channel][0]

  return {
    dimension: dimension.value,
    dimensionLabel: dimension.label,
  }
}
